import React, { useEffect, useState } from "react";
import { apiFetch } from "../lib/api";
import AdWizard from "../components/AdWizard";

export default function AdsDashboard() {
  const [isFbConnected, setIsFbConnected] = useState(false);
  const [smartLinks, setSmartLinks] = useState([]);
  const [showWizard, setShowWizard] = useState(false);

  const checkStatus = async () => {
    try {
      // Create an endpoint /api/fb/status to check this, 
      // or just try to fetch interests and catch the 400 error
      await apiFetch("/api/fb/interests?q=test"); 
      setIsFbConnected(true);
    } catch {
      setIsFbConnected(false);
    }
  };

  const connectFacebook = async () => {
    const res = await apiFetch("/api/auth/facebook/start");
    window.location.href = res.url;
  };

  useEffect(() => {
    checkStatus();
    // Fetch smart links (assumes endpoint exists)
    // apiFetch("/api/smart-links").then(res => setSmartLinks(res.items));
    // For demo:
    setSmartLinks([{ id: 'demo-1', title: 'My Song', artist: 'Me', slug: 'my-song' }]);
  }, []);

  return (
    <div className="psl-shell">
      <div className="psl-subnav">
        <div className="psl-brand"><span>Ads Manager</span></div>
      </div>

      <div className="psl-main" style={{ padding: 20 }}>
        
        {/* State 1: Facebook Not Connected */}
        {!isFbConnected && (
          <div className="psl-empty-card" style={{ maxWidth: 500, margin: '40px auto' }}>
            <h2>Connect Facebook Ads</h2>
            <p>To launch campaigns, we need permission to manage your ad account.</p>
            <button 
              className="psl-btn primary" 
              style={{ width: '100%', marginTop: 20, background: '#1877F2' }}
              onClick={connectFacebook}
            >
              Connect with Facebook
            </button>
          </div>
        )}

        {/* State 2: Dashboard */}
        {isFbConnected && (
          <div>
            <div style={{display:'flex', justifyContent:'space-between', marginBottom: 20}}>
              <h3>Your Smart Links</h3>
              <button className="psl-btn primary" onClick={() => setShowWizard(true)}>
                + New Campaign
              </button>
            </div>

            <div className="psl-tableblock">
              <table className="psl-table">
                <thead><tr><th>Release</th><th>Slug</th><th>Actions</th></tr></thead>
                <tbody>
                  {smartLinks.map(link => (
                    <tr key={link.id}>
                      <td><b>{link.title}</b><br/><span className="psl-muted">{link.artist}</span></td>
                      <td>
                        <a href={`/l/${link.slug}`} target="_blank" className="psl-url">
                          musicbase.io/l/{link.slug}
                        </a>
                      </td>
                      <td>
                        <button className="psl-btn psl-btn--micro">Stats</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {showWizard && (
          <AdWizard 
            onClose={() => setShowWizard(false)} 
            smartLinks={smartLinks} 
          />
        )}
      </div>
    </div>
  );
}